import { Entity } from '../../../core/context/entity';

export class Zone extends Entity {
    description: string;
    parentZoneId?: string;
    isInternal: boolean;
    exposureId?: string;

    constructor({
        id,
        name,
        description,
        parentZoneId,
        isInternal,
        exposureId,
    }: {
        id: string;
        name?: string;
        description: string;
        parentZoneId?: string;
        isInternal: boolean;
        exposureId?: string;
    }) {
        super({ id, name });
        this.description = description;
        this.parentZoneId = parentZoneId;
        this.isInternal = isInternal;
        this.exposureId = exposureId;
    }
}
